import React, { useState, useEffect } from "react";
//import "./styles.css";
import { Row, Col, Button, Modal, Form } from "react-bootstrap";
import LeftpanelMember from "../../components/leftpanel/leftpanel-member";
import HeaderPart from "../../components/layout/header/header";
import LoadingOverlay from "react-loading-overlay";
import "./dashboard-member.css";
import StarAccessModal from "../../components/star-access-modal";

import {
  Banner_1,
  Shopping,
  Certificatebanner,
  TrainingVideos,
  ResourcesBanner,
  PrefferedPartners,
  AffiliateDashboard,
  tvi_star_image,
  escapeTrips,
} from "../../assets/images";
import axios from "../../axios/axios";
import { message } from "antd";
import apiConfig from "../../config/api.config";
import { setSuccessCode } from "../../actions/signUp.actions";
import { useSelector, useDispatch } from "react-redux";
import Moment from "react-moment";
import countryConfig from "../../config/country.config";

const DashboardPart = () => {
  const [user, setUser] = useState(
    localStorage.getItem("userDetails")
      ? JSON.parse(localStorage.getItem("userDetails"))
      : null
  );
  const [arriviaUserId, setArriviaUserId] = useState(
    user ? user.arriviaUserId : null
  );
  const [show, setShow] = useState(false);
  const [first, setFirst] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [arrivia_password, setArriviaPassword] = useState("");
  const [country, setCountry] = useState("");
  const [last, setLast] = useState("");
  const [address, setAddress] = useState("");
  const [loadTravel, setLoadTravel] = useState("");
  const [subPackagePrice, setSubPackagePrice] = useState("");
  const [starAccessModalShow, setStarAccessModalShow] = useState(false);
  const [arriviaLoader , setArriviaLoader] = useState(false);
  const [events, setEvents] = useState([]);

  const successModal = useSelector((state) => state.changeStep.successCode);
  const dispatch = useDispatch();
  const starModalCose = () => {
    setStarAccessModalShow(false);
  };
  const modalClose = () => {
    setLoadTravel(false);
    setShow(false);
  };
  const getBaseURL = () => {
    switch (process.env.ENV) {
      case "STAGING":
        return process.env.REACT_APP_API_URL_STAGING;

      case "DEVELOPEMENT":
        return process.env.REACT_APP_API_URL_LOCAL;

      default:
        return process.env.REACT_APP_API_URL_STAGING;
    }
  };
  const handleFirst = (event) => {
    switch (event.target.name) {
      case "first":
        setFirst(event.target.value);
        break;
      case "last":
        setLast(event.target.value);
        break;
      case "address":
        setAddress(event.target.value);
        break;
      case "city":
        setCity(event.target.value);
        break;
      case "phone":
        setPhone(event.target.value);
        break;
      case "arrivia_password":
        setArriviaPassword(event.target.value);
        break;

      default:
        setCountry(event.target.value);
        break;
    }
  };
  const modalShow = () => setShow(true);
  const arriviaRegister = async () => {
    let isRegistered = false;
    if (!first || !phone || !city || !country || !last || !address || !arrivia_password) {
      message.warning("Please fill up the form properly");
    } else {
      if(arrivia_password.length < 8) {
        message.warning("Password should be at least 8 characters");
        return;
      }
      setArriviaLoader(true);
      
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("AuthToken")}`,
        },
      };
      
      let data = {
        firstName: first,
        lastName: last,
        phone,
        country,
        city,
        address,
        password: arrivia_password
      };
      await axios
        .post(`${apiConfig.api}user/arrivia_register`, data, config)
        .then((res) => {
          if (res.data.status) {
            modalClose();
            setArriviaLoader(false);
            message.warning("Registering to dashboard, please wait");
            setArriviaUserId(res.data.data);
            let userDetails = JSON.parse(localStorage.getItem("userDetails"));
            userDetails.arriviaUserId = res.data.data;

            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            isRegistered = true;
            window.open(apiConfig.arriviaRedirectUrl + res.data.data, "_blank");
          } else {
             setArriviaLoader(false);
            message.error("Something went wrong. Login failed!");
          }
        })
        .catch((err) => {
           setArriviaLoader(false);
          console.log("err", err);
          message.error(
            err.response.data.message ??
              "Something went wrong. Please try again letter"
          );
        });

      if (isRegistered) {
         modalClose();
        setArriviaLoader(false);
        message.success("User is successfully registered.");
      } else {
        setArriviaLoader(false);
      }
    }
  };
  useEffect(() => {
    if (!localStorage.getItem("AuthToken")) {
      window.open("/login", "_self");
    }
    if (user) {
      axios
        .get(`user/get-user-id-by-affiliate-details/${user.id}`)
        .then((res) => {
          if (res.data.status) {
            setSubPackagePrice(res.data.data?.belongsToUser?.packagePrice);
            localStorage.setItem(
              "subPrice",
              res.data.data?.belongsToUser?.packagePrice
            );
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  }, [user]);

  useEffect(() => {}, [successModal]);

  const handleModalCloseSuccess = () => {
    dispatch(setSuccessCode(false));
  };

  const arriviaLogin = async () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("AuthToken")}` },
    };
    if (!arriviaUserId) {
      modalShow();
      return 0;
    }
    setLoadTravel(true);
    // message.success("Redirecting to dashboard. Please wait...");
    // else message.success("Redrecting you to TravelDeals dashboard, please wait");
    await axios
      .post(`${apiConfig.api}user/arrivia_login`, {}, config)
      .then((res) => {
        if (res.data.status) {
          setLoadTravel(false);
          window.open(apiConfig.arriviaRedirectUrl + res.data.data, "_blank");
        } else {
          setLoadTravel(false);
          message.error("Something went wrong. Login failed!");
        }
      })
      .catch((err) => {
        setLoadTravel(false);
        message.error(
          err.response.data.message ??
            "Something went wrong. Please try again letter"
        );
      });
  };

  useEffect(() => {
    getUpcomingEvents();
  }, []);

  const getUpcomingEvents = () => {
    axios
      .post("/selected-calendar", { portal: "TripValetIncentive" })
      .then((res) => {
        if (res.data.status) {
          setEvents(res.data.data);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log("err", err);
        message.error(
          err.response.data.message ?? "Something went wrong. Please try again"
        );
      });
  };

  return (
    <div>
      <HeaderPart userDetails={user} />
      {/* <LoadingOverlay active={false} spinner text="Loading ..."> */}
      <div className="main_cont">
        <LeftpanelMember
          arriviaLogin={() => {
            arriviaLogin();
          }}
        />
        <div className="right_cont">
          <div className="right_banner_banner_cnt">
            <Row>
              <Col lg="6" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a
                    href="/travel-certificate-dashboard"
                    className="banner_box"
                    target="_blank"
                  >
                    <img src={Certificatebanner} className="img-fluid" alt="" />
                    <div className="banner_overlay">Certificates</div>
                  </a>
                </div>
              </Col>

              <Col lg="6" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a
                    target="_blank"
                    href="/training-video-dashboard"
                    className="banner_box"
                  >
                    <img src={TrainingVideos} className="img-fluid" alt="" />
                    <div className="banner_overlay">Training Videos</div>
                  </a>
                </div>
              </Col>
              <Col lg="6" md="6" sm="12" className="right_innrBanner">
                <LoadingOverlay active={loadTravel} spinner text="Redirecting to TravelDeals Dashboard...Please wait..">
                  <div className="right_inner_inner_banner">
                    <a
                      href="#"
                      className="banner_box"
                      onClick={() => {
                        arriviaLogin();
                      }}
                    >
                      <img src={Banner_1} className="img-fluid" alt="" />
                      <div className="banner_overlay">
                        Travel Deals
                        <p className="banner_small_text">
                          First time users fill out "Don't have an account? Sign
                          Up"
                        </p>
                      </div>
                    </a>
                  </div>
                </LoadingOverlay>
                {/* <div className="right_inner_inner_banner">
                    <a
                      href="#"
                      className="banner_box"
                      onClick={() => {
                        arriviaLogin();
                      }}
                    >
                      <img src={Banner_1} className="img-fluid" alt="" />
                      <div className="banner_overlay">Travel Deals</div>
                    </a>
                  </div> */}
              </Col>

              <Col lg="6" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a
                    href={getBaseURL() + "user/benifithub"}
                    // to={links.length ? links[0].link : "/coming-soon"}
                    target="_blank"
                    className="banner_box"
                    rel="noreferrer"
                  >
                    <img src={Shopping} className="img-fluid" alt="" />
                    <div className="banner_overlay">
                      Shopping & Entertainment
                      <p className="banner_small_text">
                        First time users fill out "Don't have an account? Sign
                        Up"
                      </p>
                    </div>
                  </a>
                </div>
              </Col>

              {/* {(subPackagePrice && subPackagePrice == "4997") ||
              subPackagePrice == "1997" ? (
                <>
                  <Col lg="6" md="6" sm="12" className="right_innrBanner">
                    <div className="right_inner_inner_banner">
                      <a
                        href="/tvi-star-dashboard"
                        className="banner_box"
                        target="_blank"
                      >
                        <img
                          src={tvi_star_image}
                          className="img-fluid"
                          alt=""
                        />
                      </a>
                    </div>
                  </Col>
                </>
              ) : (
                <>
                  <Col lg="6" md="6" sm="12" className="right_innrBanner">
                    <div className="right_inner_inner_banner">
                      <a
                        href="javascript:void(0)"
                        onClick={(e) => {
                          setStarAccessModalShow(true);
                        }}
                        className="banner_box"
                      >
                        <img
                          src={tvi_star_image}
                          className="img-fluid"
                          alt=""
                        />
                      </a>
                    </div>
                  </Col>
                </>
              )} */}

              <Col lg="6" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a
                    href="/resources-dashboard"
                    className="banner_box"
                    target="_blank"
                  >
                    <img src={ResourcesBanner} className="img-fluid" alt="" />
                    <div className="banner_overlay">Resources</div>
                  </a>
                </div>
              </Col>

              <Col lg="6" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a
                    href="/preferred-partner"
                    target="_blank"
                    className="banner_box"
                  >
                    <img src={PrefferedPartners} className="img-fluid" alt="" />
                    <div className="banner_overlay">Preferred Partners</div>
                  </a>
                </div>
              </Col>

              <Col lg="6" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a
                    href="#"
                    className="banner_box"
                  >
                    <img src={escapeTrips} className="img-fluid" alt="" />
                    {/* <div className="banner_overlay">Preferred Partners</div> */}
                  </a>
                </div>
              </Col>

              {user && user.affiliate == "" ? (
                <Col lg="6" md="6" sm="12" className="right_innrBanner">
                  <div className="right_inner_inner_banner">
                    <a href="/affiliate-dashboard" className="banner_box">
                      <img
                        src={AffiliateDashboard}
                        className="img-fluid"
                        alt=""
                      />
                      {/* <div className="banner_overlay1">Affiliate Dashboard</div> */}
                    </a>
                  </div>
                </Col>
              ) : (
                ""
              )}

              {/* <Col lg="6" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a
                    href="#"
                    onClick={() => {
                      window.open(
                        "https://www.tripvaletincentives.com/affiliate"
                      );
                    }}
                    className="banner_box"
                  >
                    <img src={ReferFriend} className="img-fluid" alt="" />
                    <div className="banner_overlay">Refer a friend</div>
                  </a>
                </div>
              </Col> */}
            </Row>
          </div>

          <div className="right_banner_banner_cnt">
            <div className="event_heading">
              <h1>Upcoming Events</h1>
            </div>
            {events.length > 0 ? (
              <div className="event_image_group">
                {events.map((item, key) => {
                  return (
                    <div className="event_image_inner_group" key={key}>
                      <div className="event_image_inner_box">
                        <a
                          href={item.calendarImg}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={item.calendarImg}
                            className="img-fluid"
                            alt="calendarImg"
                          />
                          <p>
                            <Moment format="DD-MMM-YYYY">{item.date}</Moment>
                          </p>
                        </a>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <>
                <h1>No Upcoming Event Found</h1>
              </>
            )}
          </div>
        </div>
      </div>
      {/* </LoadingOverlay> */}
      {starAccessModalShow ? (
        <>
          <StarAccessModal
            show={starAccessModalShow}
            starModalCose={starModalCose}
          />
        </>
      ) : (
        <></>
      )}
      <Modal show={show}>
        <Modal.Body>
          <div className="popuptext">
            <Button
              variant="secondary"
              className="close_button"
              onClick={modalClose}
            ></Button>
            <h3>Title</h3>
            <div className="modal_form_group">
              <LoadingOverlay active={arriviaLoader} spinner text="">
              <Form>
                <Row>
                  <Col lg="6" md="6" sm="12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>First Name *</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter first name"
                        name="first"
                        className="modal_t_field"
                        value={first}
                        onChange={handleFirst}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="6" md="6" sm="12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Last Name *</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter last name"
                        className="modal_t_field "
                        name="last"
                        value={last}
                        onChange={handleFirst}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Contact Number *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Phone Number"
                    className="modal_t_field"
                    name="phone"
                    value={phone}
                    onChange={handleFirst}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Address *</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    className="modal_t_area"
                    placeholder="Enter Address"
                    name="address"
                    value={address}
                    onChange={handleFirst}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>City *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter City"
                    className="modal_t_field"
                    name="city"
                    value={city}
                    onChange={handleFirst}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Country *</Form.Label>
                  <Form.Control
                    as="select"
                    className="modal_t_field"
                    name="country"
                    value={country}
                    onChange={handleFirst}
                  >
                     {countryConfig.map((value, key) => {
                      return (
                        <option key={key} value={value.key}>
                          {value.label}
                        </option>
                      );
                    })}
                  </Form.Control>
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Password *<small className="text-danger">(At least 8 characters)</small></Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter Password"
                    className="modal_t_field1"
                    name="arrivia_password"
                    value={arrivia_password}
                    onChange={handleFirst}
                  />
                </Form.Group>
                <div className="modal_submit">
                  <Button
                    variant="primary"
                    type="button"
                    className="sub_but"
                    onClick={() => {
                      arriviaRegister();
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </Form>
              </LoadingOverlay>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={successModal} onHide={handleModalCloseSuccess}>
        <Modal.Body>
          <div className="modal_close">
            <h2 className="text-center">Congratulations!</h2>
            <h3>You have successfully updated your new membership plan.</h3>
            <Button
              variant="secondary"
              onClick={handleModalCloseSuccess}
              className="close_buuut"
            ></Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default DashboardPart;
